/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

export enum ComplianceTaskDefinitionResponseDtoLatestInstanceStatus {
  NOT_YET_DUE = "NOT_YET_DUE",
  DUE_SOON = "DUE_SOON",
  OVERDUE = "OVERDUE",
  AWAITING_EVIDENCE = "AWAITING_EVIDENCE",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}
